export default {
  methods: {
    showSnackbar(message, state) {
      if (state) {
        this.$store.commit('setSnackbarState', state);
      }
      this.$store.commit('showSnackbar', message);

      if (this.snackbarTimer) {
        clearTimeout(this.snackbarTimer);
      }
    },
    alertSnackbar(message, state) {
      // pop open snackbar for a few seconds
      this.showSnackbar(message, state);
      this.snackbarTimer = setTimeout(() => {
        this.hideSnackbar();
      }, 4500);
    },
    hideSnackbar() {
      this.$store.commit('hideSnackbar');
    },
  },
};
